import React, { useState, useEffect } from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import {
  Chip,
  Paper,
  withStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
} from "@material-ui/core";
import Button from '@mui/material/Button';
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Loader from "../../components/loader";
import moment from "moment";
import { MessageRounded } from "@material-ui/icons";
import SendReportModel from "./sendReportModel";
import CallIcon from "@material-ui/icons/Call";
import CheckCircleRoundedIcon from "@material-ui/icons/CheckCircleRounded";
import CancelRoundedIcon from '@material-ui/icons/CancelRounded';
import LocalAtmIcon from "@material-ui/icons/LocalAtm";
import { Grid, Select, MenuItem, TextField } from "@material-ui/core";
import NoteAddIcon from "@material-ui/icons/NoteAdd";
import { CALL_DISABLE_TIME } from "../../../CallTimeDisable";
import { clickToCallBooking } from "../../actions/OffLineSupportActions";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    buttonContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-around",
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    paper: {
      marginTop: "2rem",
      padding: "0.5rem 2rem",
      width: "100%",
    },
    table: {
      maxWidth: "100%",
      margin: "auto",
    },
    conlorChange: {
      background: "red",
    },
    tableContainer: {
      marginTop: "2rem",
      position: "sticky",
      top: "200px",
    },
    content: {
      width: "80%",
      flexGrow: 21,
      //   padding: theme.spacing(3),
    },
  })
);
const StyledTableCell: any = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: "#0E3F6C",
      color: theme.palette.common.white,
      fontSize: "14px",
    },
    body: {
      fontSize: 14,
    },
  })
)(TableCell);
const StyledTableRow: any = withStyles((theme: Theme) =>
  createStyles({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  })
)(TableRow);

interface Props {
  page: any;
  setPage: any;
  setLeadId: any;
  setPaymentId: any;
  paymentId: any;
  failedReport: any;
  getFailedReportData: any;
  loading: boolean;
  clickToCallBooking: Function;
  setFilterUrl: any;
  filterUrl: any;
}

const BookingsTable: React.FC<Props> = ({
  page,
  setPage,
  setLeadId,
  clickToCallBooking,
  failedReport,
  getFailedReportData,
  loading,
  setFilterUrl,
  filterUrl,
}) => {
  const classes = useStyles();
  const [customerDetails, setCustomerDetails] = useState<any>("");
  const [objId, setObjId] = useState<any>("");
  const [lead, setLead] = useState<number>(0);
  const [openReportModel, setOpenReportModel] = useState<boolean>(false);
  const [callButton, setCallButton] = useState<boolean>(true);

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    if (newPage > page) {
      let url = failedReport.links && failedReport.links.next.split("?")[1];
      getFailedReportData(url);
    } else if (newPage < page) {
      let url = failedReport.links && failedReport.links.previous.split("?")[1];
      getFailedReportData(url);
    }
    setPage(newPage as number);
  };

  const handleSendReport = (data: any) => {
    setCustomerDetails(data);
    setObjId(data?.id);
    setOpenReportModel(!openReportModel);
  };

  useEffect(() => {
    if (!openReportModel) {
      setCustomerDetails("");
    }
  }, [openReportModel])

  const handleCallClick = (id: number, type: string) => {
    // setLeadId(id);
    setCallButton(false);
    clickToCallBooking(id, type);
    setTimeout(() => {
      setCallButton(true);
    }, CALL_DISABLE_TIME);
  };

  return (
    <main className={classes.content}>
      <TableContainer
        className={classes.tableContainer}
        component={Paper}
        style={{ maxHeight: "700px" }}
      >
        {loading ? (
          <Loader />
        ) : (
          <Table stickyHeader aria-label="simple table">
            <TableHead>
              <StyledTableRow>
                <StyledTableCell align="center">Ticket Id</StyledTableCell>
                <StyledTableCell align="center">Booking Id</StyledTableCell>
                <StyledTableCell align="center">Reason</StyledTableCell>
                <StyledTableCell align="center">Email Confirmation</StyledTableCell>
                <StyledTableCell align="center">Whatsapp Confirmation</StyledTableCell>
                <StyledTableCell align="center">Send Report</StyledTableCell>
                <StyledTableCell align="center">Action</StyledTableCell>
                <StyledTableCell align="center">Child Id</StyledTableCell>
                <StyledTableCell align="center">Child Name</StyledTableCell>
                <StyledTableCell align="center">Lead</StyledTableCell>
                <StyledTableCell align="center">Call</StyledTableCell>
                <StyledTableCell align="center">Patient Name</StyledTableCell>
                <StyledTableCell align="center">Status</StyledTableCell>
                <StyledTableCell align="center">
                  Collection Date
                </StyledTableCell>
                <StyledTableCell align="center">Booking Status</StyledTableCell>
                <StyledTableCell align="center">Remarks </StyledTableCell>
                <StyledTableCell align="center">Create Date </StyledTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {failedReport?.results &&
                failedReport?.results?.length > 0 &&
                failedReport?.results.map((booking: any, index: any) => {
                  return (
                    <StyledTableRow key={index}>
                      <StyledTableCell align="center">
                        {booking?.id}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {booking?.booking?.id}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {booking?.reason || "NA"}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {booking?.email_sent ? <CheckCircleRoundedIcon style={{ color: "green" }}/> : <CancelRoundedIcon style={{ color: "red" }}/>}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {booking?.whatsapp_sent ? <CheckCircleRoundedIcon style={{ color: "green" }}/> : <CancelRoundedIcon style={{ color: "red" }}/>}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <Button
                          variant="contained"
                          color="secondary"
                          fullWidth
                          onClick={() => handleSendReport(booking)}
                        >
                          Send
                        </Button>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <Link
                          to={`/dashboard/os/booking-view/${booking?.booking?.id}`}
                          style={{ textDecoration: "none" }}
                        >
                          <Button variant="contained" color="secondary">
                            View
                          </Button>
                        </Link>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {booking?.add_member_booking !== null
                          ? booking?.add_member_booking?.id
                          : ""}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {booking?.add_member_booking !== null
                          ? booking?.add_member_booking?.name
                          : ""}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {booking?.booking?.lead}
                      </StyledTableCell>

                      <StyledTableCell component="th" scope="row">
                        <Button
                          disabled={!callButton}
                          className="addDeck"
                          variant="contained"
                          color="primary"
                          onClick={() =>
                            handleCallClick(booking?.booking?.id, "call")
                          }
                          startIcon={<CallIcon />}
                        ></Button>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {booking?.booking?.name || "N/A"}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <Chip
                          label={`${booking?.report_sent_status}`}
                          style={{
                            background:
                              booking?.report_status === "pending"
                                ? "#ffee58"
                                : booking.report_status === "consolidate"
                                ? "#00e676"
                                : booking?.report_status === "partial"
                                ? "#d500f9"
                                : "#ff3d00",
                          }}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {new Date(
                          booking?.booking?.collection_date
                        ).toLocaleString()}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <Chip
                          label={`${booking?.booking?.booking_status}`}
                          style={{
                            background:
                              booking?.booking?.booking_status === "pending"
                                ? "#ffee58"
                                : booking?.booking?.booking_status ===
                                  "consolidate"
                                ? "#00e676"
                                : booking?.booking?.booking_status === "partial"
                                ? "#d500f9"
                                : "#ff3d00",
                          }}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {booking?.remarks || "NA"}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {new Date(booking?.created_at).toLocaleString()}
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })}
            </TableBody>
            <TableFooter>
              <StyledTableRow>
                <TablePagination
                  rowsPerPageOptions={[]}
                  colSpan={3}
                  count={failedReport?.count || 0}
                  rowsPerPage={failedReport?.page_size || 20}
                  page={page}
                  onPageChange={handleChangePage}
                />
              </StyledTableRow>
            </TableFooter>
          </Table>
        )}
      </TableContainer>
      <SendReportModel
        setOpenReportModel={setOpenReportModel}
        openReportModel={openReportModel}
        customerDetails={customerDetails}
        setCustomerDetails={setCustomerDetails}
        objId={objId}
        setFilterUrl={setFilterUrl}
        filterUrl={filterUrl}
        getFailedReportData={getFailedReportData}
      />
    </main>
  );
};

const mapStateToProps = (state: any) => ({});

export default connect(mapStateToProps, {
  clickToCallBooking,
})(BookingsTable);